import {
    FETCH_RATER_HEATMAP_START,
    FETCH_RATER_HEATMAP_SUCCESS,
    FETCH_RATER_HEATMAP_FAIL,

} from "../../../constants";
import {
    FETCH_RATER_HEATMAP_URL,
} from "../../../../../config/constants";
import { createVisualizationFetchAction } from "./createVisualizationFetchAction";

export const getRaterHeatmap = createVisualizationFetchAction(FETCH_RATER_HEATMAP_URL, {
    START: FETCH_RATER_HEATMAP_START,
    SUCCESS: FETCH_RATER_HEATMAP_SUCCESS,
    FAIL: FETCH_RATER_HEATMAP_FAIL,
});

